import { Button } from "@mui/material";

export default function Year2024() {
  return (
    <div className="history2021">
      <div>
        <h1>Türkiye 29. Zeka Oyunları Yarışması</h1>
        <h2>
          <strong>OYUN 2024’ün Sonuçları Açıklandı!</strong>
        </h2>
      </div>

      <div>
        <img
          style={{ maxWidth: 800, width: "100%" }}
          src="/assets/images/oyun-2023-final.jpg"
        />
        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Türkiye 29. Zeka Oyunları Yarışması “Oyun 2024” final sınavı ODTÜ'de
          gerçekleşti.
        </h3>
        <p style={{ textAlign: "left" }}>
          Türkiye Zeka Vakfı’nın her yıl düzenlediği ve zihinleri zorlayan Zeka
          Oyunları Yarışması bu yıl 29. kez gerçekleştirildi. “OYUN 2024”te
          Eleme ve Yarı Final aşamalarını başarıyla tamamlayan finalistler,
          Türkiye’nin dört bir yanından gelerek 19 Ekim Cumartesi günü Orta Doğu
          Teknik Üniversitesi’nde (ODTÜ) buluştu.
        </p>
        {/* <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Okuma-yazma ve dört işlem becerileri ile geçen bir cumartesi
        </h3> */}
        <p style={{ textAlign: "left" }}>
          Sözel, sayısal, görsel ve mantık alanlarında hazırlanan özgün
          sorularla donatılan bu büyük final; “Minikler”, “Çocuklar”, “Gençler”,
          “Yetişkinler” ve “Emektarlar” kategorilerinde yapıldı. Yarışma boyunca
          her yaş grubundan katılımcı, sınav süresince farklı düşünme
          becerilerini sınama fırsatı buldu.
        </p>
        {/* <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Yediden yetmişe değil, beşten yetmiş sekize
        </h3> */}
        <p style={{ textAlign: "left" }}>
          Eleme Sınavı, 31 Temmuz Çarşamba gününe kadar çevrim içi olarak
          tamamlandı. Ardından gelen Yarı Final Sınavı ise 31 Ağustos Cumartesi
          günü, yine çevrim içi olarak, 13.00–14.00 saatleri arasında
          gerçekleşti. Final Sınavı ve Ödül Töreni ise yüz yüze olarak ODTÜ
          Fizik Bölümü’nde düzenlendi.
        </p>

        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          81 İlden Gelen Katılımla Gerçek Bir Türkiye Mozaiği
        </h3>
        <p style={{ textAlign: "left" }}>
          OYUN 2024’e bu yıl da 81 ilden yoğun bir ilgi vardı. Final sürecine
          katılan yarışmacılar arasında, daha önce bu deneyimi yaşayan ve
          ODTÜ’yle ilk kez tanışan birçok isim de yer aldı. Bu tanışıklığın bazı
          yarışmacılara üniversite tercihlerinde yön verdiği gözlemlendi.
        </p>
        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>Ödül töreni</h3>
        <p style={{ textAlign: "left" }}>
          Ödül töreninde Türkiye Zeka Vakfı Başkanı Emrehan Halıcı, 29 yıldır
          süregelen bu köklü organizasyonun değerini ve ülke genelinde yarattığı
          farkındalığı vurgulayan bir konuşma gerçekleştirdi. Tüm finalistler
          tek tek tebrik edildi, başarıları alkışlandı.
        </p>
        <h3 style={{ paddingTop: "20px", textAlign: "left" }}>
          Şeref Kürsüsünde Başarı Öyküleri
        </h3>
        <p style={{ textAlign: "left" }}>
          Her kategoride dereceye giren yarışmacıların kısa özgeçmişleri ve
          fotoğrafları, “Şeref Kürsüsü” sayfasında yayınlandı.
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: "10px",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        {/* <Button
          color="secondary"
          style={{
            marginLeft: 3,
            marginRight: 3,
            marginBottom: 6,
          }}
          variant="contained"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://halici.pixieset.com/oyun2023/"
            style={{ color: "white", textDecoration: "none" }}
          >
            Fotoğraf Galerisi
          </a>
        </Button> */}
        <Button
          color="secondary"
          style={{
            marginLeft: 3,
            marginRight: 3,
            marginBottom: 6,
          }}
          variant="contained"
        >
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://oyun.tzv.org.tr/hall_of_fame"
            style={{ color: "white", textDecoration: "none" }}
          >
            Dereceye Giren Yarışmacılar
          </a>
        </Button>
      </div>
    </div>
  );
}
